import React from 'react';

const ThankYou = () => {
  return (
    <div className="hero-section" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '20px',
      overflow: 'auto'
    }}>
      <div className="max-width2 vertical align-center gap-30 full-width">
        <div className="hero-section-text">
          <h1 className="big-text" style={{ marginBottom: '20px' }}>
            Thank You for Your Support!
          </h1>
          <p style={{
            maxWidth: '650px',
            margin: '0 auto 30px',
            fontSize: '18px',
            lineHeight: '1.6',
            color: 'rgba(255, 255, 255, 0.9)'
          }}>
            Your support brings us closer to a Michigan that puts people over politics. This campaign is just getting started—and we’re stronger with you on our side.
          </p>
        </div>

        {/* Join CTA */}
        <div className="horizontal gap-20 justify-center" style={{ flexWrap: 'wrap' }}>
          <a href="/home" className="btn-primary-primary" style={{
          }}>
            Back to home
          </a>
        </div>

        {/* Socials */}
        <div className="share-section" style={{
          marginTop: '40px',
          color: 'rgba(255, 255, 255, 0.8)',
          fontSize: '14px'
        }}>
          Stay connected with Ren Nushaj’s journey:
          <div className="horizontal gap-10 justify-center" style={{ marginTop: '10px' }}>
            <a href="https://www.facebook.com/people/Ren-Nushaj-for-MI-Senate/61575864823768/#" target="_blank" rel="noreferrer">
              <i className="bi bi-facebook" style={{ fontSize: '24px', color: 'var(--primary)' }}></i>
            </a>
            <a href="https://www.linkedin.com/in/ren-nushaj-a9bb549/" target="_blank" rel="noreferrer">
              <i className="bi bi-linkedin" style={{ fontSize: '24px', color: 'var(--primary)' }}></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
